import { render } from "./WelcomeViewV2.vue?vue&type=template&id=e18c9146&scoped=true"
import script from "./WelcomeViewV2.vue?vue&type=script&lang=js"
export * from "./WelcomeViewV2.vue?vue&type=script&lang=js"

import "./WelcomeViewV2.vue?vue&type=style&index=0&id=e18c9146&lang=scss&scoped=true"
import "./WelcomeViewV2.vue?vue&type=style&index=1&id=e18c9146&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e18c9146"]])

export default __exports__